import { render } from "./Navigation.vue?vue&type=template&id=36cbffda&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=36cbffda&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\workInProgress\\invoice-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cbffda"]])

export default __exports__